

// $Classes/Enums/Interfaces(filter)[template][separator]
// filter (optional): Matches the name or full name of the current item. * = match any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
// template: The template to repeat for each matched item
// separator (optional): A separator template that is placed between all templates e.g. $Properties[public $name: $Type][, ]

// More info: http://frhagn.github.io/Typewriter/

import { Project } from './Project';
import { ModeOfOperation } from './ModeOfOperation';
import { PT_ProtectiveFunction } from './PT_ProtectiveFunction';
import { PM_ProtectiveFunction } from './PM_ProtectiveFunction';

export class ProtectiveFunction {
    
    public protectiveId: number = 0;
    public redundant: string = null;
    public isRedundant: boolean = null;
    public source: string = null;
    public projectKey: string = null;
    public functionId: string = null;
    public softKey: string = null;
    public softKeyDescription: string = null;
    public functionName: string = null;
    public createdBy: number = null;
    public createdDate: Date = null;
    public updatedBy: number = null;
    public updatedByUserName: string = null;
    public updatedDate: Date = null;
    public lockDate: Date = null;
    public deleteFlag: boolean = null;
    public devicesMatchMasterPool: boolean = false;
    public projectId_PrtId: number = 0;
    public project: Project = null;
    public import: string = null;
    public importProcess: string = null;
    public manualInputRedundancy: string = null;
    public isManualInputRedundant: boolean = null;
    public modeOfOperation: ModeOfOperation = null;
    public displayModeOfOperation: string = null;
    public rowVersion: number[] = [];
    public isLocked: boolean = false;
    public ptProtectiveFunctions: PT_ProtectiveFunction[] = [];
    public pmProtectiveFunctions: PM_ProtectiveFunction[] = [];
}

